/**
 * 조상에 display:none / visibility:hidden 이 있으면 false.
 * ERP 탭은 비활성 시 display:none 유지·컴포넌트 마운트 유지 →
 * window 단축키 리스너가 숨은 탭에서 먼저 가로채지 않도록 판별에 사용.
 */
export function isElementVisible(el) {
  if (!el || !el.isConnected) return false;
  let node = el;
  while (node && node.nodeType === 1) {
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    node = node.parentElement;
  }
  return true;
}

/** Alt + F1~F12 여부 (e.key만 보면 IME/브라우저에서 빗나갈 수 있어 code 병행) */
export function isAltFunctionKey(e, fnName) {
  if (!e || !e.altKey || e.ctrlKey || e.metaKey) return false;
  const want = String(fnName || '').toUpperCase();
  const key = String(e.key || '').toUpperCase();
  const code = String(e.code || '').toUpperCase();
  return key === want || code === want;
}
